"use client";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

const CountDown = ({ changeHeader, endDate }) => {
  const t = useTranslations();
  const apiDate = new Date(endDate);
  const [timer, setTimer] = useState();
  const [time, setTime] = useState(timeRemaining());

  useEffect(() => {
    if (
      time.day === 0 &&
      time.hour === 0 &&
      time.minute === 0 &&
      time.second === 0
    ) {
      clearInterval(timer);
      return changeHeader((state) => !state);
    } else {
      const intervalId = setInterval(() => {
        const remainingTime = timeRemaining();
        setTime(remainingTime);
      }, 1000);
      setTimer(intervalId);
    }
    return () => clearInterval(timer);
  }, [time]);

  function timeRemaining() {
    const today = new Date();
    const difference = apiDate - today;
    if (difference <= 0) {
      clearInterval(timer);
      return { day: 0, hour: 0, minute: 0, second: 0 };
    }
    let day = Math.floor(difference / (1000 * 60 * 60 * 24));
    let hour = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minute = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    let second = Math.floor((difference % (1000 * 60)) / 1000);
    return { day, hour, minute, second };
  }
  return (
    <div className="flex xmd2:my-10 sm:my-6 my-2 xmd2:scale-100 sm:scale-75 scale-50">
      <div className="innerTimer m-2.5">
        <span>{time.day}</span>
        <p>{t("day")}</p>
      </div>
      <span className="text-[32px] leading-[80px]">:</span>
      <div className="innerTimer m-2.5">
        <span>{time.hour}</span>
        <p>{t("hours")}</p>
      </div>
      <span className="text-[32px] leading-[80px]">:</span>
      <div className="innerTimer m-2.5">
        <span>{time.minute}</span>
        <p>{t("minutes")}</p>
      </div>
      <span className="text-[32px] leading-[80px]">:</span>
      <div className="innerTimer m-2.5">
        <span>{time.second}</span>
        <p>{t("seconds")}</p>
      </div>
    </div>
  );
};

export { CountDown };
